import { useEphattaQuery } from "../../utils/useEphattaQuery"
import { useAdvertService } from "./useAdvertService"

export const useAdvertTypes = () => {
    const service = useAdvertService()
    return useEphattaQuery("Adverts.Types", () => service.types())
} 